<div class="d-flex flex-nowrap align-items-end">
    <kendo-floatinglabel
        invClass
        [isValid]="isValid"
        [text]="labelText"
        class="flex-row">
        <kendo-dateinput
            *ngIf="isStartTime"
            kendoDateRangeStartInput
            [min]="minDate"
            [max]="maxDate"
            [(ngModel)]="date"
            (ngModelChange)="onDateChange()"
            [disabled]="isDatePickerDisabled"
            invClass
            [isValid]="dateIsValid">
        </kendo-dateinput>
        <kendo-dateinput
            *ngIf="!isStartTime"
            kendoDateRangeEndInput
            [min]="minDate"
            [max]="maxDate"
            [(ngModel)]="date"
            (ngModelChange)="onDateChange()"
            [disabled]="isDatePickerDisabled"
            invClass
            [isValid]="dateIsValid">
        </kendo-dateinput>
        <kendo-timepicker
            *ngIf="displayTimePicker"
            [(ngModel)]="date"
            (ngModelChange)="onDateChange()"
            #dateModel="ngModel"
            [disabled]="isDatePickerDisabled"
            invClass
            [isValid]="dateIsValid">
        </kendo-timepicker>
    </kendo-floatinglabel>
    <div class="k-vstack ml-4 flex-shrink-0">
        <kendo-checkbox
            [label]="checkBoxAMText"
            [(value)]="checkBoxAM"
            (valueChange)="onAMChange()"
            [disabled]="isAMCheckboxDisabled"
            [inputClass]="inputClass">
        </kendo-checkbox>
        <kendo-checkbox
            [label]="checkBoxPMText"
            [(value)]="checkBoxPM"
            (valueChange)="onPMChange()"
            [disabled]="isPMCheckboxDisabled"
            [inputClass]="inputClass">
        </kendo-checkbox>
    </div>
</div>
<div
    *ngIf="!dateIsValid && !!inValidMsg"
    class="text-red font-smaller-1 mt-2">
    {{ inValidMsg }}
</div>
